/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoScheduleEmployee implements angular.IDirective {
        restrict = "E";
        scope = {
            currentValue: "=ngModel",
            someCtrlFn: "&",
            dates: "=",
            filter: "="
        };

        templateUrl = "app/components/controls/meevoScheduleEmployee.html";

        constructor(private $window: ng.IWindowService, private modalService: Meevo.Components.Modal.IModalService) {
           
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.items = scope.currentValue;
            scope.window = this.$window;
            var modalService = this.modalService;
            var arrSize = scope.items.length;


            scope.showCustomModal = (employee) :void =>  {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/schedules/modals/employeeDay.template.html",
                    controller: "meevo.plugins.schedules.SchedulesModalController",
                    controllerAs: "vm",
                    clickOutsideToClose: true,
                    locals: {
                        employee: employee
                    } 
                }
                this.modalService.showCustom(options);
            }

            scope.showPhoneModal = (employee): void => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/schedules/modals/employeeMonth.template.html",
                    controller: "meevo.plugins.schedules.MonthModalController",
                    controllerAs: "vm",
                    clickOutsideToClose: true,
                    locals: {
                        employee: employee
                    }
                }
                this.modalService.showCustom(options);
            }

            scope.compareDates = (startTime: any, day: any): boolean => {
                if (moment(startTime).format('MMDDYY') == day.format('MMDDYY')){
                    return true;
                }
                return false;
            }
        }


        static factory(): angular.IDirectiveFactory {
            let directive = ($window, modalService) => {
                return new MeevoScheduleEmployee($window, modalService);
            };

            directive.$inject = ["$window", "meevo.components.modal.ModalService"];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoScheduleEmployee", MeevoScheduleEmployee.factory());
}